export class EvaluacionContextoModel{
    idEvaluacionContexto:number;
    idJardinPeriodo:number;
    respuesta1:number;
    respuesta2:String;
    respuesta3:number;
    respuesta4:number;
    respuesta5:number;
    respuesta6:number;
    respuesta71:boolean;
    respuesta72:boolean;
    respuesta73:boolean;
    respuesta74:boolean;
    respuesta75:boolean;
    respuesta7Otro:String;
    respuesta8:String;
    respuesta9:String;
    respuesta10:String;
    estado:String;
}
